// extracted by mini-css-extract-plugin
export default {"LeadScan":"LeadScan-module-b3dddd15657634d40638","buttons":"LeadScan-module-e3941b4e97d8fd2ae9ee"};